import React from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Typography from "components/basic/typography";

interface ModalHeaderProps {
  isEdit: boolean;
  onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ isEdit, onClose }) => {
  const { t } = useTranslation("calendar");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        mb: 2,
      }}
    >
      <Typography variant="h4" style={{ fontWeight: 600 }}>
        {isEdit ? t("booking.edit") : t("booking.new")}
      </Typography>
      <IconButton
        onClick={onClose}
        size="small"
        sx={{ position: "absolute", right: 0 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default ModalHeader;
